import { addItem, removeItems } from 'actions/CheckoutActions'
import type { AppAction } from 'actions/types/ActionTypes'
import { goBack } from 'lib/routing/appRouting'
import { getCurrentIntl } from 'i18n/util/currentIntl'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import getIsLoyaltyEsimUpsellPostPurchaseCheckout from 'checkout/selectors/loyalty/esim/getIsLoyaltyEsimUpsellPostPurchaseCheckout'
import { generateLoyaltyEsimUpsellCheckoutItem } from 'lib/checkout/experiences/cart'
import type { LoyaltyEsimUpsellModalResult } from 'loyalty/components/LoyaltyEsimUpsellModal'

export function applyEsimUpsellCheckoutSelection(
  selection: LoyaltyEsimUpsellModalResult,
): AppAction {
  return (dispatch, getState) => {
    const intl = getCurrentIntl()
    const { esimOfferId } = selection
    if (!esimOfferId) {
      showSnackbar(
        intl.formatMessage({
          id: '0pXtduyE00DbZyPnwg7I',
          defaultMessage: 'This add-on is not available yet. Please try again later.',
          description: 'Warning snackbar when eSIM upsell data is unavailable',
        }),
        'warning',
      )
      return
    }

    const state = getState()

    if (selection.kind === 'removeUpsell') {
      const existingIds = state.checkout.cart.items
        .filter((item): item is App.Checkout.ExperienceItem =>
          item.itemType === 'experience' && item.experienceId === esimOfferId,
        )
        .map(item => item.itemId)

      if (existingIds.length > 0) {
        dispatch(removeItems(existingIds))
      }

      if (getIsLoyaltyEsimUpsellPostPurchaseCheckout(state)) {
        dispatch(goBack())
        return
      }
      showSnackbar(
        intl.formatMessage({
          id: '1csV7dPzKPDMyCOVdCgW',
          defaultMessage: 'Included eSIM restored for this trip.',
          description: 'Success snackbar when user removes eSIM upsell selection',
        }),
        'success',
      )
      return
    }

    const { experience, selectedTicket, countryCode, currentPackage } = selection
    if (!experience || !countryCode || !currentPackage) {
      showSnackbar(
        intl.formatMessage({
          id: '0pXtduyE00DbZyPnwg7I',
          defaultMessage: 'This add-on is not available yet. Please try again later.',
          description: 'Warning snackbar when eSIM upsell data is unavailable',
        }),
        'warning',
      )
      return
    }

    const item = generateLoyaltyEsimUpsellCheckoutItem(experience, selectedTicket, {
      countryCode,
      currentPackage,
    })

    const existingIds = getState().checkout.cart.items
      .filter((i): i is App.Checkout.ExperienceItem =>
        i.itemType === 'experience' && i.experienceId === esimOfferId,
      )
      .map(i => i.itemId)

    if (existingIds.length > 0) {
      dispatch(removeItems(existingIds))
    }
    dispatch(addItem(item))
    showSnackbar(
      intl.formatMessage({
        id: 'JQNvcBjWqYTw6JIZlHJE',
        defaultMessage: 'Add-on added to your trip.',
        description: 'Success snackbar when eSIM upsell is added to cart',
      }),
      'success',
    )
  }
}
